import React, { useState, useRef, useEffect } from 'react';
import { Row, Col, Space, Popover, Badge } from 'antd';
import { Button } from 'witmeg-ui-system'
import { useSelector, useDispatch } from "react-redux";
import axios from 'axios';
import _ from "lodash";
import "@fontsource/inter";
import "@fontsource/jost";
import config from "react-global-configuration";
import './MenuNavbar.scss';
import { useHistory } from 'react-router-dom';
import { getCompanyAllPagesInfo, updateOrderTypeDetails } from '../../../RestaurantWidget/utilities/api/restaurantsService';
import profile from "../../assets/profile-2.svg"
import cart from "../../assets/cart-shopping.svg"
import menu from "../../assets/menu.svg"
import search from "../../assets/search-normal.svg"
import notification from "../../assets/notification.svg"
import close from "../../assets/close.svg"
import loc from "../../assets/location-black.svg"
import clock from "../../assets/clock-five.svg"
import IMAGE_PLACEHOLDER from "../../assets/images/Images/empty-placeholder.png"
import deliveryIc from "../../assets/delivery-cycle.svg"
import collectionIC from "../../assets/shop.svg"
import searchIC from "../../assets/search-v2.svg"


import { getAllData, setOrderData, setSelectedOrderType } from '../../../../../../../redux/resturantWidgetSlice';
import { isECommerceProcessPath, LOCAL_STORAGE_ITEMS_NAMES, setLocalStorageData } from '../../../RestaurantWidget/utilities/helper/helper';
import moment from 'moment';
import { setSelectedOffer } from '../../../../../../../redux/companyDataSlice';
const MenuNavbarV3 = ({ setIsDrawerOpen, setAddDeliveryLoc, setIsLeftDrawerOpen, setCollectionStore, setShowLogin, setIsStoreClosed }) => {

    const orderTypes = [
        { name: "Collection", type: "collection", typeValue: "TAKE_AWAY" },
        // { name: "Dine-in", type: "table", typeValue: "DINE_IN" },
        { name: "Delivery", type: "delivery", typeValue: "DELIVERY_BY_REWARDCONSUMER" },

    ]
    const filteredData = () => {
        const availableTypes = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).orderTypes
        const val = orderTypes.filter(item => availableTypes?.includes(item.type));
        return val
    }

    const dispatch = useDispatch()
    const { selectedOrderType } = useSelector((state) => state.resturantData);
    const { companies } = useSelector((state) => state.companyData);
    const company = useSelector((state) => state.companyData.company);

    const [data, setData] = useState(null)

    const [searchKey, setSearchKey] = useState('')
    const [items, setItems] = useState([])
    const history = useHistory()
    const [state, setState] = useState({
        menusize: 0,
        menus: "",
        pages: [],
        categories: [],
        brands: [],
        basketitem: [],
        // hasResturantWidget: null,
        cloudLocations: [],
        locationsDropdown: [],
        selectedLocation: {},
        visibleCartSummaryPopup: false,
        showDropdown: false,
        redirect: false,
        activeDropdown: null,

        locations: [],
        defaultLocation: {},

        updateCartItemPopup: {
            visible: false,
            data: null,
            index: null,
            editData: null,
        },
    });
    const userDetails = localStorage.getItem('DELIVERY_DATA')
    let parsedUserDetails = JSON.parse(localStorage.getItem('DELIVERY_DATA'))
    const addressDelivery = userDetails ? parsedUserDetails.Addresses.find((address) => address.AddressType === "Delivery") : null
    const restaurantDataState = useSelector((state) => state.resturantData);
    const companyDataState = useSelector((state) => state.companyData);
    const storeClosed = useSelector((state) => state.companyData.storeClosed);

    const resize = () => {
        if (window.innerWidth > 1681) {
            setState((prevState) => ({ ...prevState, menusize: 5 }));
        } else if (window.innerWidth < 1400 && window.innerWidth > 1150) {
            setState((prevState) => ({ ...prevState, menusize: 2 }));
        } else {
            setState((prevState) => ({ ...prevState, menusize: 3 }));
        }
    };
    const containerRef = useRef(null);
    useEffect(() => {
        fetchDBData()
    }, []);
    const fetchDBData = async () => {
        await getAllData().then((result) => {
            setData(result?.data);
            if (result?.data && result?.data?.Categories && result?.data?.Categories?.length > 0) {
                let array = result?.data.Categories.map((val) => {
                    return val.MenuEntities.map((menuEntity) => {
                        const menuItem = _.find(result?.data.Items, { MenuItemID: menuEntity.ID });
                        return { ...menuItem, Category: val.Title.en };
                    });
                }).flat();

                setItems(array)
            }
        });
    }
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setSearchKey("");
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        window.addEventListener("resize", resize);
        resize();

        const _initData = async () => {
            const __response = await getCompanyAllPagesInfo({
                ID: "",
                CompanyID: config.get("companyID"),
            });

            let __pages = __response
                .filter((z) => z.DraftMainPagesInfoID === "")
                .map((y) => {
                    return {
                        ...y,
                        children: __response.filter(
                            (a) => a.DraftMainPagesInfoID === y.ID
                        ),
                    };
                });
            setState((prevState) => ({ ...prevState, pages: __pages }));
        };
        _initData();
    }, []);



    useEffect(() => {
        if (
            restaurantDataState.resturantCloudLocations &&
            restaurantDataState.resturantCloudLocations.length > 0 &&
            restaurantDataState.defualtSelectedLocation
        ) {
            const _locations = restaurantDataState.resturantCloudLocations.map(
                (__location) => ({
                    label: __location.CloudLocationName,
                    value: __location.CloudLocationID,
                })
            );

            const _defaultLocation = _.find(_locations, {
                value: restaurantDataState.defualtSelectedLocation
                    .CloudLocationID,
            });

            setState((prevState) => ({
                ...prevState,
                locations: _locations,
                defaultLocation: _defaultLocation,
                selectedLocation: _defaultLocation,
            }));
        }
    }, [
        restaurantDataState.resturantCloudLocations,
        restaurantDataState.defualtSelectedLocation,
    ]);

    useEffect(() => {
        if (companyDataState && companyDataState.companyDetails && companyDataState.companyDetails.organizationID) {
            axios.post(process.env.REACT_APP_TOKENSERVICE_URL, {
                isLoginServerRequest: false,
                serviceName: "productRegistry",
            }).then(async function (authresponse) {
                const requestOptions = {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authresponse.data.token}`,
                    }
                };

                let OrgID = companyDataState.companyDetails.organizationID

                axios.get(`${process.env.REACT_APP_rest_API_productregistry}/onlinecategories/${OrgID}`, requestOptions).then((categoryData) => {
                    if (categoryData.data.Status) {
                        //log
                    }
                })
            })
        }
    }, [companyDataState.companyDetails])


    useEffect(() => {
        if (data && data?.Categories && data?.Categories?.length > 0) {
            let array = data.Categories.map((val) => {
                return val.MenuEntities.map((menuEntity) => {
                    const menuItem = _.find(data.Items, { MenuItemID: menuEntity.ID });
                    return { ...menuItem, Category: val.Title.en };
                });
            }).flat();

            setItems(array)
        }
    }, [searchKey])
    const searchedItems = (searchingValue) => {
        return items.filter(item => item.Title && item.Title.en && item.Title.en.toLowerCase().includes(searchingValue.toLowerCase()));
    }
    const toggleCartSummaryPopover = () => {
        setState((prevState) => ({
            ...prevState,
            visibleCartSummaryPopup: !prevState.visibleCartSummaryPopup,
        }));
    };

    const changeUpdateCartItemPopupVisibility = (_visible, _data = null) => {
        if (_visible) {
            setState((prevState) => ({
                ...prevState,
                updateCartItemPopup: {
                    visible: true,
                    data: _data.data,
                    editData: _data.editData,
                    index: _data.index,
                },
            }));
            toggleCartSummaryPopover();
        } else {
            setState((prevState) => ({
                ...prevState,
                updateCartItemPopup: {
                    visible: false,
                    data: null,
                    editData: null,
                    index: null,
                },
            }));
        }
    };



    const handleLogout = () => {
        sessionStorage.clear()
        localStorage.clear()
        window.location.href = '/'
    };
    const updateOrderType = (type) => {
        let body = {
            "OrderID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID),
            "DeliveryType": type,
            "CountryCode": "GB"
        }
        updateOrderTypeDetails(body).then((res) => {
            dispatch(setOrderData(res))
        })

    }
    const getFormatSchedule = () => {
        const iso = JSON.parse(localStorage.getItem("schedule_order"))?.StartTime;
        if (!iso) return "";

        const date = moment.utc(iso);
        const today = moment();
        const isToday = date.isSame(today, 'day');
        const isTomorrow = date.isSame(today.clone().add(1, 'day'), 'day');

        if (isToday) return "Today, " + date.format('hh:mm A');
        if (isTomorrow) return "Tomorrow,  " + date.format('hh:mm A');

        return date.format('MMM DD, hh:mm A');
    }
    return (
        <div className='Hospitality-Menu-Nav-V3'>
            <div className="Hospitality-navbar-fixed-header">
                <Row align="middle">
                    <Col xs={window.screen.width < 1200 ? 12 : 3} className='Hospitality-navbar-menu-logo'>
                        <img
                            className="menu-icon-cont"
                            src={menu}
                            alt="Menu Icon"
                            onClick={() => {
                                setIsLeftDrawerOpen(true)
                            }}
                            style={{ cursor: 'pointer' }}
                        />
                        {/* <Drawer /> */}

                        <div className="Hospitality-navbar-logo">
                            <a
                                className="eco-navbar-logo"
                                href={!restaurantDataState.hasResturantWidget && `/`}
                            >
                                <img
                                    style={{ maxHeight: "48px" }}
                                    src={config.get("companyLogo")}
                                    draggable="false"
                                />
                            </a>
                        </div>
                        {/* <Space className='Hospitality-navbar-menu-tab'>
                            <a href="/" style={{ color: "white" }}>Menu</a>
                            {!isECommerceProcessPath() &&
                                state.pages.map((pn, index) => (
                                    <>
                                        {pn.children.length === 0 &&
                                            pn.ShowInMainMenu === true && (
                                                <a
                                                    href={`/pages/${pn.Slug}`}
                                                    style={{ color: "white" }}
                                                >
                                                    {pn.PageName}
                                                </a>
                                            )}
                                    </>
                                ))
                            }
                        </Space> */}
                    </Col>
                    {
                        <Col xs={17} className='Hospitality-navbar-menu'>
                            {selectedOrderType === "" || (window.location.pathname.includes("/order") || window.location.pathname.includes("/account")) || window.location.pathname.includes("/vouchers") ? "" : selectedOrderType !== "table" && <Space className='Hospitality-navbar-menu-tab-right'>

                                {selectedOrderType === "delivery" && addressDelivery?.City && <div className='location-delivery'
                                    onClick={() => {
                                        setAddDeliveryLoc(true)
                                    }}>
                                    <img alt='' src={loc} />{addressDelivery?.City}, UK</div>}

                                {localStorage.getItem("schedule_order") ?
                                    <div className='location-delivery'
                                        onClick={() => {
                                            setIsStoreClosed(true)
                                        }}>
                                        <img alt='' src={clock} />{getFormatSchedule()}</div> : ""}

                                <div className='type-selection'>
                                    {filteredData().map((orderType, index) => {
                                        return (
                                            <div key={index} className={`Hospitality-navbar-menu-order-type ${selectedOrderType === orderType.type ? "Hospitality-navbar-menu-order-type-selected" : ""} `} onClick={() => {

                                                if (orderType.type === "delivery") {
                                                    setAddDeliveryLoc(true)
                                                } else {
                                                    if (companies.length > 1) {
                                                        setCollectionStore(true)
                                                    } else {
                                                        updateOrderType(orderType.typeValue)
                                                        localStorage.setItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_STR_LOC_ID, company.LocationID)
                                                        dispatch(setSelectedOrderType(orderType.type))
                                                        localStorage.removeItem("schedule_order")
                                                    }
                                                }
                                            }}>
                                                <div className={`menu-order-type-radio`} >
                                                    <img alt='' src={orderType.type === "collection" ? collectionIC : deliveryIc} className='type-icon' />
                                                </div>
                                                {orderType.name}{storeClosed[orderType.type] && <div className='order-close'>Closed</div>}</div>
                                        )
                                    })}
                                </div>


                            </Space>}

                            {selectedOrderType === "" || (window.location.pathname.includes("/order") || window.location.pathname.includes("/account")) || window.location.pathname.includes("/vouchers") ?
                                "" : <div className='search-wrapper-cont' ref={containerRef} >
                                    <div className='search-container'>
                                        <img alt='' src={search} className='search-image' />
                                        <input className='search-input' placeholder='Search for dishes, restaurants...' value={searchKey} onChange={e => { setSearchKey(e.target.value) }} />
                                        {searchKey !== "" && < img alt='' src={close} className='close-image' onClick={() => { setSearchKey("") }} />}
                                    </div>
                                    {searchKey !== "" &&
                                        <div className='searched-container'>
                                            {searchedItems(searchKey).length > 0 ? searchedItems(searchKey).map((value, index) => {
                                                return (
                                                    <div key={index} className='searched-item-cont' onClick={() => {
                                                        localStorage.removeItem("OFF_QT")
                                                        localStorage.removeItem("MODQUANTITY")
                                                        localStorage.removeItem("ECOM_OFF_SL")
                                                        dispatch(setSelectedOffer(value.MenuItemID + "/new"))
                                                        setSearchKey("")
                                                    }}>
                                                        <img style={{ objectFit: !value.ImageURL ? "fill" : "" }} alt='' className='searched-image-cont' src={value.ImageURL ? value.ImageURL : IMAGE_PLACEHOLDER} />
                                                        <div className='items-cont'>
                                                            <div className='searched-title'>
                                                                {value.Title.en}</div>
                                                            <div className='searched-cat'>{value.Category}</div></div></div>
                                                )
                                            }) : <div className='empty-search'>No results found for <b>{searchKey}</b></div>}</div>}
                                </div>
                            }
                        </Col>}
                    <Col xs={window.screen.width < 1200 ? 12 : 4} className='Hospitality-navbar-user-prof'>
                        <Row>
                            <Col>
                                <Row align="middle">
                                    <Col className='Hospitality-navbar-search-in-menu'>
                                        <div className='Hospitality-navbar-search-in-menu-icon'>
                                            {selectedOrderType === "" || (window.location.pathname.includes("/order") || window.location.pathname.includes("/account")) ? "" : < img className='Hospitality-navbar-search-in-menu-icon' src={searchIC} onClick={() => {
                                                history.push("/item/search")
                                            }} />}
                                        </div>
                                    </Col>
                                    <Col className='Hospitality-navbar-sign-in-menu'>
                                        {localStorage.getItem('isLogged') !== 'true' &&

                                            <div className='Hospitality-navbar-sign-in-menu-icon-prof' onClick={() => { setShowLogin(true) }}>
                                                <img alt='' src={profile} className='Hospitality-navbar-sign-in-menu-icon-profile' />
                                            </div>}

                                    </Col>
                                </Row>
                            </Col>


                        </Row>

                    </Col>
                </Row>

            </div >
            <div className='mob-order-selection'>
                {selectedOrderType === "" || (window.location.pathname.includes("/order") || window.location.pathname.includes("/account")) || window.location.pathname.includes("/vouchers") ? "" : selectedOrderType !== "table" && <Space className='Hospitality-navbar-menu-mob'>
                    {filteredData().map((orderType, index) => {
                        return (
                            <div key={index} className={`Hospitality-navbar-menu-order-type-mob ${selectedOrderType === orderType.type ? "Hospitality-navbar-menu-order-type-mob-selected" : ""} `} onClick={() => {

                                if (orderType.type === "delivery") {
                                    setAddDeliveryLoc(true)
                                } else {
                                    updateOrderType(orderType.typeValue)
                                    localStorage.setItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_STR_LOC_ID, company.LocationID)
                                    dispatch(setSelectedOrderType(orderType.type))
                                    localStorage.removeItem("schedule_order")
                                }
                            }}>
                                {orderType.name}{storeClosed[orderType.type] && <div className='order-close'>Closed</div>}</div>
                        )
                    })}
                </Space>}
                <div className='location-delivery-mobile-wrap'>
                    {selectedOrderType === "" || (window.location.pathname.includes("/order") || window.location.pathname.includes("/account")) ? "" : selectedOrderType === "delivery" && addressDelivery?.City &&
                        <div className='location-delivery-mobile'
                            onClick={() => {
                                setAddDeliveryLoc(true)
                            }}>
                            <img alt='' src={loc} />{addressDelivery?.City}</div>}
                    {localStorage.getItem("schedule_order") ?
                        <div className='location-delivery-mobile'
                            onClick={() => {
                                setIsStoreClosed(true)
                            }}>
                            <img alt='' src={clock} />{getFormatSchedule()}</div> : ""}
                </div>

            </div>
        </div >
    );
};

export default MenuNavbarV3;